import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgClock = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14 2.625A11.375 11.375 0 1 0 25.375 14 11.387 11.387 0 0 0 14 2.625Zm0 21A9.625 9.625 0 1 1 23.625 14 9.636 9.636 0 0 1 14 23.625ZM21 14a.875.875 0 0 1-.875.875H14a.875.875 0 0 1-.875-.875V7.875a.875.875 0 0 1 1.75 0v5.25h5.25A.875.875 0 0 1 21 14Z" />
  </svg>
);
export default SvgClock;
